import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorPage, AppErrorBoundary, isKnownFrontendPath } from './ErrorPage.tsx'
import { I18nProvider } from './i18n'
import { applyThemeToDom, getInitialTheme } from './theme/themeTransition'

applyThemeToDom(getInitialTheme(), { persist: false })

document.getElementById('ssr-fallback')?.remove()

const content = isKnownFrontendPath(window.location.pathname) ? (
  <I18nProvider>
    <App />
  </I18nProvider>
) : (
  <ErrorPage code="404" />
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>{content}</AppErrorBoundary>
  </StrictMode>,
)
